import { ENTITY_NAMES } from "@miplatform/constants";

const ESTIMATING_ITEM_GROUPS = {
  ESTIMATING: "", // No group header
  BIDS: "Bids",
  CONFIGURATION: "Configurations",
  PRICING: "Pricing",
};

export const estimatingNavItems = [
  {
    name: `${ENTITY_NAMES.BID_REQUESTS}`,
    path: "/estimating/bids",
    testId: "nav-item-bids",
    group: ESTIMATING_ITEM_GROUPS.BIDS,
  },
  {
    name: "Attributes",
    path: "/estimating/configuration/attributes",
    testId: "nav-item-configuration-attributes",
    group: ESTIMATING_ITEM_GROUPS.CONFIGURATION,
  },
  {
    name: "Categories",
    path: "/estimating/configuration/categories",
    testId: "nav-item-configuration-categories",
    group: ESTIMATING_ITEM_GROUPS.CONFIGURATION,
  },
  {
    name: "Items",
    path: "/estimating/configuration/items",
    testId: "nav-item-configuration-items",
    group: ESTIMATING_ITEM_GROUPS.CONFIGURATION,
  },
  {
    name: "Areas",
    path: "/estimating/configuration/area-types",
    testId: "nav-item-configuration-area-types",
    group: ESTIMATING_ITEM_GROUPS.CONFIGURATION,
  },
  {
    name: "Requirements",
    path: "/estimating/configuration/requirements",
    testId: "nav-item-configuration-requirements",
    group: ESTIMATING_ITEM_GROUPS.CONFIGURATION,
  },
  {
    name: "Series",
    path: "/estimating/pricing/series",
    testId: "nav-item-pricing-series",
    group: ESTIMATING_ITEM_GROUPS.PRICING,
  },
  {
    name: "Drop Types",
    path: "/estimating/pricing/drop-types",
    testId: "nav-item-pricing-drop-types",
    group: ESTIMATING_ITEM_GROUPS.PRICING,
  },
  {
    name: "Pricing Matrix",
    path: "/estimating/pricing/pricing-matrix",
    testId: "nav-item-pricing-pricing-matrix",
    group: ESTIMATING_ITEM_GROUPS.PRICING,
  },
  {
    name: "Customers",
    path: "/estimating/pricing/customers",
    testId: "nav-item-pricing-customers",
    group: ESTIMATING_ITEM_GROUPS.PRICING,
  },
];
